import { useRef, useState } from "react";
import { authController } from "@reedexpo/authorization-component-ui";
import { Routes } from "../../../../routes";

export const useIdleModal = () => {
  const [secondsLeft, setSecondsLeft] = useState(300);
  const timer = useRef<NodeJS.Timeout | null>(null);

  const handleTimerEnd = () => {
    const config = window["authSettings"];
    authController.initialize(config);
    authController.logout(Routes.homepage);
  };

  const startTimer = () => {
    setSecondsLeft(300);
    if (timer.current) clearInterval(timer.current);
    timer.current = setInterval(() => {
      setSecondsLeft(prevState => {
        const newValue = prevState - 1;
        if (newValue <= 0) {
          if (timer.current) clearInterval(timer.current);
          handleTimerEnd();
          return 0;
        }
        return newValue;
      });
    }, 1000);
  };

  const clearTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
  };

  return { startTimer, secondsLeft, clearTimer };
};
